class AdapterMap {
    adapter: any;
    config: any;
    host: string;
    path: string;
}

export class DataLayerConfig {
    entityNameSpaces: string[];
    entityAdapterMappings: any;
    defaultHost: string;
    defaultPath: string;
}
